import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';
import OrdersService    from '@/services/Orders';
import { loadScript }   from "@paypal/paypal-js";
let singleton = Symbol();
let singletonEnforcer = Symbol();

class CardService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._paypalScript = null;
    this._indentPayment = null;
    this._methods = null;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new CardService(singletonEnforcer);
    }
    return this[singleton];
  }

  get paypalConfig() {
    return this._paypal;
  }

  initPayment() {
    if (OrdersService.cart.cartPayment.method.code === 'cb-stripe') return this.initStripe();
    else if (OrdersService.cart.cartPayment.method.code === 'cb-paypal') return this.initPaypalCB();
    else if (OrdersService.cart.cartPayment.method.code === 'paypal') return this.initPaypal();
    else return Promise.reject('Method payment is invalid');
  }

  initStripe() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/orders/${OrdersService.cart.id}/payments/${OrdersService.cart.cartPayment.id}/configuration`).then(res => {
        if (res.data.publishable_key) {
          this._stripe = window.Stripe(res.data.publishable_key);
          this._indentPayment = res.data.client_secret;
          this._cardElement = this.getCardElements();
          resolve(this._cardElement);
        } else reject(new Error('no publish key defined'));
      }).catch(reject);
    });
  }

  initPaypal() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/orders/${OrdersService.cart.id}/payments/${OrdersService.cart.cartPayment.id}/configuration`).then(res => {
        this._paypal = res.data;
        loadScript({
          'client-id': res.data.client_id,
          currency: res.data.currency,
          'disable-funding': 'credit,card,bancontact,blik,eps,giropay,ideal,mybank,p24,sepa,sofort,venmo'
        }).then(resolve).catch(reject);
      });
    });
  }

  initPaypalCB() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/orders/${OrdersService.cart.id}/payments/${OrdersService.cart.cartPayment.id}/configuration`).then(res => {
        this._paypal = res.data;
        if (!this._paypalScript) {
          const firstScript = document.getElementsByTagName('script')[0];
          this._paypalScript = document.createElement('script');
          this._paypalScript.type = 'text/javascript';
          this._paypalScript.setAttribute('data-client-token', res.data.client_token)
          this._paypalScript.async = true;
          this._paypalScript.onload = resolve;
          this._paypalScript.src = `https://www.paypal.com/sdk/js?components=hosted-fields&client-id=${res.data.client_id}`;
          firstScript.parentNode.insertBefore(this._paypalScript, firstScript);
        } else {
          this._paypalScript.setAttribute('data-client-token', res.data.client_token);
          resolve();
        }
      }).catch(reject);
    });
  }

  createPaypalCB() {
    return axios.post(this._paypal.create_paypal_order_url);
  }

  confirmPaypalCB() {
    return axios.post(this._paypal.complete_paypal_order_url);
  }

  getMethods() {
    return new Promise((resolve) => {
      if (this._methods) {
        resolve(this._methods);
        return;
      }
      axios.get(`/api/v2/payments/methods`).then(res => {
        this._methods = res.data['hydra:member'];
        resolve(this._methods);
      })
    })
  }

  getCardElements() {
    const options = {
      style: {
        base: {
          color: '#000',
          fontFamily: 'Dia, Arial',
          fontSize: '13px',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#636363',
          },
          ':-webkit-autofill': {
            color: '#000',
          }
        }
      },
      classes: {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid',
      }
    };
    const cardElement = this._stripe.elements({
      // fonts: [{
      //   family: 'Dia',
      //   src: 'url(https://mad-et-len-cms.awstudio.website/files/dia-regular_51e364af4b669d0ce49ee8b461c9f064.woff)'
      // }]
    });
    const card = {
      cardElement: cardElement
    }
    card.cardNumber = card.cardElement.create('cardNumber', {
      ...options,
      preferredNetwork: ['cartes_bancaires', 'mastercard', 'visa'],
      showIcon: true
    });
    card.cardExpiry = card.cardElement.create('cardExpiry', options);
    card.cardCvc = card.cardElement.create('cardCvc', options);
    return card;
  }

  paymentFree(order) {
    const seq = axios.get(`/api/v2/orders/${order.id}/complete/free`);
    seq.catch(console.error);
    return seq;
  }

  paymentStripe(cardNumber) {
    return new Promise((resolve, reject) => {
      if (!this._indentPayment) return reject(new Error('indent payment not exist'));
      this._stripe.confirmCardPayment(this._indentPayment, {
        payment_method: {
          card: cardNumber
        },
      }).then(result => {
        if (result.paymentIntent) {
          resolve(result.paymentIntent);
        } else if (result.error) {
          reject(result);
        }
      }).catch(reject);
    });
  }
}
export default CardService.getInstance();
